import type { FC } from "react";
import { Link } from "react-router";
import { ACTION_ITEM_LABEL } from "../../../libs/mypage/actionItems";
import { normalizeOrderCode } from "../../../libs/mypage/orderCode";
import { formatDate, formatYen, type OrderSummaryDTO } from "./format";
import { StatusLabel } from "./StatusLabel";

type Props = {
  order: OrderSummaryDTO;
};

export const OrderSummaryRow: FC<Props> = ({ order }) => (
  // 注文番号の先頭 `#` は URL に含めない (`#` は URL fragment マーカーで proxy 越しに扱いが不安定なため)。
  // 表示には `order.code` (例: "#S12345") をそのまま使い、URL slug は `#` を除いた形にする。
  <Link
    to={`/orders/${normalizeOrderCode(order.code)}`}
    className="group flex items-center gap-4 py-4"
  >
    <img
      src={order.thumbnailUrl}
      alt=""
      width={64}
      height={64}
      className="size-16 flex-shrink-0 rounded border border-neutral-200 bg-neutral-50 object-cover"
    />
    <div className="min-w-0 flex-1">
      <div className="flex items-baseline justify-between gap-3">
        <p className="truncate font-medium text-neutral-900 text-sm group-hover:underline">
          {order.representativeTitle}
          {order.itemCount > 1 && (
            <span className="ml-1 text-neutral-500 text-xs">他 {order.itemCount - 1} 点</span>
          )}
        </p>
        <p className="flex-shrink-0 text-neutral-700 text-sm">{formatYen(order.totalPriceJpy)}</p>
      </div>
      <p className="mt-1 text-neutral-500 text-xs">
        注文番号 {order.code} ・ {formatDate(order.createdAt)}
      </p>
      <p className="mt-1.5">
        <StatusLabel order={order} />
      </p>
      {order.actionItems.length > 0 && (
        <p className="mt-1 text-amber-700 text-xs">
          ご対応のお願い: {order.actionItems.map((a) => ACTION_ITEM_LABEL[a.kind]).join("・")}
        </p>
      )}
    </div>
  </Link>
);
